export default __webpack_public_path__ + "resources/icons/n242-fd49.png";